export default "__VITE_ASSET__C19bG_VG__"